"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/stream/v1/internal_common.proto (package spwn.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = exports.StreamingVideo = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * StreamingVideoメッセージの定義
 *
 * @generated from message spwn.stream.v1.StreamingVideo
 */
class StreamingVideo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 配信ビデオのID
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * イベントID
         *
         * @generated from field: string event_id = 2;
         */
        this.eventId = "";
        /**
         * ビデオの名前
         *
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * 配信開始時刻
         *
         * @generated from field: int64 start_at = 4;
         */
        this.startAt = protobuf_1.protoInt64.zero;
        /**
         * 配信終了時刻
         *
         * @generated from field: int64 end_at = 5;
         */
        this.endAt = protobuf_1.protoInt64.zero;
        /**
         * ビデオの説明
         *
         * @generated from field: string description = 6;
         */
        this.description = "";
        /**
         * 配信時間のテキスト?
         *
         * @generated from field: string duration_text = 7;
         */
        this.durationText = "";
        /**
         * VOD（Video On Demand）が有効かどうか
         *
         * @generated from field: bool has_vod = 8;
         */
        this.hasVod = false;
        /**
         * チャットが有効かどうか
         *
         * @generated from field: bool is_chat_enabled = 9;
         */
        this.isChatEnabled = false;
        /**
         * ライブコマースが有効かどうか
         *
         * @generated from field: bool is_live_commerce_enabled = 10;
         */
        this.isLiveCommerceEnabled = false;
        /**
         * ライブイベントが有効かどうか
         *
         * @generated from field: bool is_live_event_enabled = 11;
         */
        this.isLiveEventEnabled = false;
        /**
         * 配信が公開されているかどうか
         *
         * @generated from field: bool is_open = 12;
         */
        this.isOpen = false;
        /**
         * リンクされたストリームの名前
         *
         * @generated from field: string linked_stream_name = 13;
         */
        this.linkedStreamName = "";
        /**
         * 優先度
         *
         * @generated from field: int32 priority = 14;
         */
        this.priority = 0;
        /**
         * ストレージパス
         *
         * @generated from field: string storage_path = 15;
         */
        this.storagePath = "";
        /**
         * サムネイル
         *
         * @generated from field: string thumbnail = 16;
         */
        this.thumbnail = "";
        /**
         * アーティストプロファイルの参照
         *
         * @generated from field: repeated string artist_profile_refs = 17;
         */
        this.artistProfileRefs = [];
        /**
         * チャットの日時
         *
         * @generated from field: int64 chat_datetime = 18;
         */
        this.chatDatetime = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StreamingVideo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StreamingVideo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StreamingVideo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(StreamingVideo, a, b);
    }
}
exports.StreamingVideo = StreamingVideo;
StreamingVideo.runtime = protobuf_1.proto3;
StreamingVideo.typeName = "spwn.stream.v1.StreamingVideo";
StreamingVideo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "end_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "duration_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "has_vod", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "is_chat_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "is_live_commerce_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "is_live_event_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "is_open", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "linked_stream_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "storage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "artist_profile_refs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 18, name: "chat_datetime", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * ステータス
 *
 * @generated from message spwn.stream.v1.Status
 */
class Status extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.stream.v1.Status.status
         */
        this.status = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Status().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Status().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Status().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Status, a, b);
    }
}
exports.Status = Status;
Status.runtime = protobuf_1.proto3;
Status.typeName = "spwn.stream.v1.Status";
Status.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "status" },
]);
//# sourceMappingURL=internal_common_pb.js.map